// import {useState,useEffect } from "react";
// import styles from "./imageGallery.module.css";
// import { FaChevronLeft, FaChevronRight, FaHeart, FaTimes } from "react-icons/fa";
// import { CiHeart } from "react-icons/ci";
// import { useNavigate } from "react-router-dom";
// import { Button,Image } from "../shared/index";
// import { getImageUrl } from "../../lib/get-image";
// import { useAddToWishList, useRemoveWishList } from "../../queries/useWishListQuery";
// import LoginPopup from "../../pages/web-app/LoginPopup/Loginpopup";
// import authService from "../../services/authService";
// const ImageGallery = ({
//   productId,
//   productName,
//   images = [],
//   wishItems = []
// }) => {
//   const [selectedImage, setSelectedImage] = useState(0);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [showLoginPopup, setShowLoginPopup] = useState(false);
// const [showZoom, setShowZoom] = useState(false);

// const [zoomPosition, setZoomPosition] = useState({
//   x: 0,
//   y: 0,
// });

// const [lensPosition, setLensPosition] = useState({
//   x: 0,
//   y: 0,
// });
// const navigate = useNavigate();
// const isLoggedIn = authService.isLoggedIn();
// const handleMouseMove = (e) => {
//   const rect = e.currentTarget.getBoundingClientRect();

//   const x = e.clientX - rect.left;
//   const y = e.clientY - rect.top;


//   const lensSize = 120;

//   let lensX = x - lensSize / 2;
//   let lensY = y - lensSize / 2;


//   // prevent lens going outside image
//   lensX = Math.max(
//     0,
//     Math.min(lensX, rect.width - lensSize)
//   );

//   lensY = Math.max(
//     0,
//     Math.min(lensY, rect.height - lensSize)
//   );


//   setLensPosition({
//     x:lensX,
//     y:lensY
//   });


//   setZoomPosition({
//     x:(lensX / rect.width) * 100,
//     y:(lensY / rect.height) * 100
//   });
// };
//   useEffect(() => {
//     setSelectedImage(0);
//   }, [images]);
//   const { mutate: addWish } = useAddToWishList();
//   const { mutate: removeWish } = useRemoveWishList();
//   const wishItem = wishItems?.find(
//     (w) => Number(w?.product_id) === Number(productId)
//   );

//   const inWishList = Boolean(wishItem);
//   const wishlistId = wishItem?.id;

//  const handleWishlist = (e) => {
//   e.preventDefault();
//   e.stopPropagation();

//   if (!isLoggedIn) {
//     setShowLoginPopup(true);
//     return;
//   }

//   if (inWishList) {
//     removeWish(wishlistId);
//   } else {
//     addWish({ product_id: productId });
//   }
// };
// const handleLoginRedirect = () => {
//   setShowLoginPopup(false);
//   navigate("/login");
// };

// const handleClosePopup = () => {
//   setShowLoginPopup(false);
// };


//   const handleOpenModal = (index) => {
//     setSelectedImage(index);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => setIsModalOpen(false);

//   const handleNextImage = () => {
//     setSelectedImage((prev) => (prev + 1) % images?.length);
//   };

//   const handlePrevImage = () => {
//     setSelectedImage((prev) => (prev - 1 + images.length) % images?.length);
//   };


//   return (
//     <>
//       <div className={styles.galleryContainer}>
//       <div
//  className={styles.mainImageWrapper}
//  onMouseEnter={() => setShowZoom(true)}
//  onMouseLeave={() => setShowZoom(false)}
//  onMouseMove={handleMouseMove}
// >

// <Image
//  src={getImageUrl(images[selectedImage]?.image)}
//  alt={productName}
//  title={productName}
//  className={styles.mainImage}
// />


// {showZoom && (
// <>
// <div
//  className={styles.zoomLens}
//  style={{
//    left:`${lensPosition.x}px`,
//    top:`${lensPosition.y}px`
//  }}
// />


// <div
//  className={styles.zoomBox}
//  style={{
//    backgroundImage:
//    `url(${getImageUrl(images[selectedImage]?.image)})`,
//    backgroundPosition:
//    `${zoomPosition.x}% ${zoomPosition.y}%`
//  }}
// />

// </>
// )}


// <Button
//  type="button"
//  title={
//    inWishList 
//    ? <FaHeart size={25} color="red"/> 
//    : <CiHeart size={25}/>
//  }
//  style={styles.wishlistButton}
//  onHandler={handleWishlist}
// />

// </div>

//         <div className={styles.thumbnailRow}>
//           <Button
//             type="button"
//             title={<FaChevronLeft size={20} />}
//             style={styles.arrowBtn}
//             onHandler={handlePrevImage}
//           />

//           <div className={styles.thumbnails}>
//             {images?.map((item, index) => (
//             <img
//   key={index}
//   src={getImageUrl(item?.image)}
//   alt={productName}
//   title={productName}
//   className={`${styles.thumbnail} ${
//     selectedImage === index ? styles.activeThumb : ""
//   }`}
//   onClick={() => setSelectedImage(index)}
// />
//             ))}
//           </div>

//           <Button
//             type="button"
//             title={<FaChevronRight size={20} />}
//             style={styles.arrowBtn}
//             onHandler={handleNextImage}
//           />
//         </div>
//       </div>

//       {isModalOpen && (
//       <ImageModal
//   images={images}
//   selectedImage={selectedImage}
//   handleCloseModal={handleCloseModal}
//   handlePrevImage={handlePrevImage}
//   handleNextImage={handleNextImage}
//   productName={productName}
// />
//       )} 
//          <LoginPopup
//       isOpen={showLoginPopup}
//       onClose={handleClosePopup}
//       onLogin={handleLoginRedirect}
//     />
//     </>
//   );
// };

// const ImageModal = ({
//   images,
//   selectedImage,
//   handleCloseModal,
//   handlePrevImage,
//   handleNextImage,
//   productName
// }) => {
//   return (
//     <div className={styles.modalOverlay}>
//       <Button
//         type="button"
//         title={<FaTimes size={20} />}
//         style={styles.closeBtn}
//         onHandler={handleCloseModal}
//       />

//       <Button
//         type="button"
//         title={<FaChevronLeft size={20} />}
//         style={styles.modalNavLeft}
//         onHandler={handlePrevImage}
//       />

//     <Image
//   src={getImageUrl(images[selectedImage]?.image)}
//   alt={productName}
//   title={productName}
//   className={styles.modalImage}
// />

//       <Button
//         type="button"
//         title={<FaChevronRight size={20} />}
//         style={styles.modalNavRight}
//         onHandler={handleNextImage}
//       /> 
    
//     </div>
//   );
// };

// export default ImageGallery;



import {useState,useEffect } from "react";
import styles from "./imageGallery.module.css";
import { FaChevronLeft, FaChevronRight, FaHeart, FaTimes } from "react-icons/fa";
import { CiHeart } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { Button,Image } from "../shared/index";
import { getImageUrl } from "../../lib/get-image";
import { useAddToWishList, useRemoveWishList } from "../../queries/useWishListQuery";
// import LoginPopup from "../../pages/web-app/LoginPopup/Loginpopup";
import authService from "../../services/authService";
const ImageGallery = ({
  productId,
  productName,
  images = [],
  wishItems = []
}) => {
  const [selectedImage, setSelectedImage] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
const [showZoom, setShowZoom] = useState(false);

const [zoomPosition, setZoomPosition] = useState({
  x: 0,
  y: 0,
});

const [lensPosition, setLensPosition] = useState({
  x: 0,
  y: 0,
});
const navigate = useNavigate();
const isLoggedIn = authService.isLoggedIn();
const handleMouseMove = (e) => {
  const rect = e.currentTarget.getBoundingClientRect();

  const lensSize = 120;

  let x = e.clientX - rect.left;
  let y = e.clientY - rect.top;

  // Keep inside image
  x = Math.max(0, Math.min(x, rect.width));
  y = Math.max(0, Math.min(y, rect.height));

  let lensX = x - lensSize / 2;
  let lensY = y - lensSize / 2;

  lensX = Math.max(0, Math.min(lensX, rect.width - lensSize));
  lensY = Math.max(0, Math.min(lensY, rect.height - lensSize));

  setLensPosition({
    x: lensX,
    y: lensY,
  });

  setZoomPosition({
    x: (x / rect.width) * 100,
    y: (y / rect.height) * 100,
  });
};
  useEffect(() => {
    setSelectedImage(0);
  }, [images]);
  const { mutate: addWish } = useAddToWishList();
  const { mutate: removeWish } = useRemoveWishList();
  const wishItem = wishItems?.find(
    (w) => Number(w?.product_id) === Number(productId)
  );

  const inWishList = Boolean(wishItem);
  const wishlistId = wishItem?.id;

 const handleWishlist = (e) => {
  e.preventDefault();
  e.stopPropagation();

  if (!isLoggedIn) {
    setShowLoginPopup(true);
    return;
  }

  if (inWishList) {
    removeWish(wishlistId);
  } else {
    addWish({ product_id: productId });
  }
};
const handleLoginRedirect = () => {
  setShowLoginPopup(false);
  navigate("/login");
};

const handleClosePopup = () => {
  setShowLoginPopup(false);
};


  const handleOpenModal = (index) => {
    setSelectedImage(index);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => setIsModalOpen(false);

  const handleNextImage = () => {
    setSelectedImage((prev) => (prev + 1) % images?.length);
  };

  const handlePrevImage = () => {
    setSelectedImage((prev) => (prev - 1 + images.length) % images?.length);
  };


  return (
    <>
      <div className={styles.galleryContainer}>
      <div
 className={styles.mainImageWrapper}
 onMouseEnter={() => setShowZoom(true)}
 onMouseLeave={() => setShowZoom(false)}
 onMouseMove={handleMouseMove}
>

<Image
 src={getImageUrl(images[selectedImage]?.image)}
 alt={productName}
 title={productName}
 className={styles.mainImage}
/>


{showZoom && (
<>
<div
 className={styles.zoomLens}
 style={{
   left:`${lensPosition.x}px`,
   top:`${lensPosition.y}px`
 }}
/>


<div
  className={styles.zoomBox}
  style={{
    backgroundImage: `url(${getImageUrl(images[selectedImage]?.image)})`,
    backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
  }}
/>

</>
)}


<Button
 type="button"
 title={
   inWishList 
   ? <FaHeart size={25} color="red"/> 
   : <CiHeart size={25}/>
 }
 style={styles.wishlistButton}
 onHandler={handleWishlist}
/>

</div>

        <div className={styles.thumbnailRow}>
          <Button
            type="button"
            title={<FaChevronLeft size={20} />}
            style={styles.arrowBtn}
            onHandler={handlePrevImage}
          />

          <div className={styles.thumbnails}>
            {images?.map((item, index) => (
            <img
  key={index}
  src={getImageUrl(item?.image)}
  alt={productName}
  title={productName}
  className={`${styles.thumbnail} ${
    selectedImage === index ? styles.activeThumb : ""
  }`}
  onClick={() => setSelectedImage(index)}
/>
            ))}
          </div>

          <Button
            type="button"
            title={<FaChevronRight size={20} />}
            style={styles.arrowBtn}
            onHandler={handleNextImage}
          />
        </div>
      </div>

      {isModalOpen && (
      <ImageModal
  images={images}
  selectedImage={selectedImage}
  handleCloseModal={handleCloseModal}
  handlePrevImage={handlePrevImage}
  handleNextImage={handleNextImage}
  productName={productName}
/>
      )} 
         {/* <LoginPopup
      isOpen={showLoginPopup}
      onClose={handleClosePopup}
      onLogin={handleLoginRedirect}
    /> */}
    </>
  );
};

const ImageModal = ({
  images,
  selectedImage,
  handleCloseModal,
  handlePrevImage,
  handleNextImage,
  productName
}) => {
  return (
    <div className={styles.modalOverlay}>
      <Button
        type="button"
        title={<FaTimes size={20} />}
        style={styles.closeBtn}
        onHandler={handleCloseModal}
      />

      <Button
        type="button"
        title={<FaChevronLeft size={20} />}
        style={styles.modalNavLeft}
        onHandler={handlePrevImage}
      />

    <Image
  src={getImageUrl(images[selectedImage]?.image)}
  alt={productName}
  title={productName}
  className={styles.modalImage}
/>

      <Button
        type="button"
        title={<FaChevronRight size={20} />}
        style={styles.modalNavRight}
        onHandler={handleNextImage}
      /> 
    
    </div>
  );
};

export default ImageGallery;
